const routeName = 'account-contact';

export default [
    {
        path: '',
        name: `${routeName}-main`,
        component: () => import('@/pages/account/account-list/contact/AccountContactIndex.vue'),
        meta: {
            auth: true,
            permission: ['sp.accounts.contacts.access'],
            breadcrumbLabel: 'Contacts',
        }
    },
    {
        path: ':id/details',
        name: `${routeName}-details`,
        component: () => import('@/pages/account/account-list/contact/AccountContactDetails.vue'),
        meta: {
            auth: true,
            permission: ['sp.accounts.contacts.view-details'],
            breadcrumbLabel: 'Contact Details',
        }
    },
];
